import React from 'react';
import { Row } from './Layout';

interface TermsOfServiceModalProps {
    onClose: () => void;
}

export const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ onClose }) => {
    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', flexDirection: 'column' }}>
            <div onClick={onClose} style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.65)',
                backdropFilter: 'blur(5px)',
                animation: 'overlayIn .3s ease'
            }} />

            <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'var(--surface)',
                borderTopLeftRadius: 30, borderTopRightRadius: 30,
                borderTop: '1px solid var(--border)',
                height: '85vh', display: 'flex', flexDirection: 'column',
                animation: 'slideUpModal .4s cubic-bezier(0.16, 1, 0.3, 1)'
            }}>
                <div style={{ padding: '20px', borderBottom: '1px solid var(--border)' }}>
                    <div style={{ width: 40, height: 4, background: 'var(--border)', borderRadius: 2, margin: '0 auto 15px' }} />
                    <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="syne" style={{ fontSize: 20, fontWeight: 800 }}>Hizmet Şartları</div>
                        <button onClick={onClose} className="icon-btn">✕</button>
                    </Row>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '20px', color: 'var(--muted)', fontSize: 13, lineHeight: 1.6 }}>
                    <h3 style={{ color: 'var(--text)', marginBottom: 10, fontSize: 15 }}>1. Giriş</h3>
                    <p style={{ marginBottom: 20 }}>
                        Buddy Live platformunu ("Uygulama") kullanarak, bu Hizmet Şartlarını ve Gizlilik Politikasını okuduğunuzu,
                        anladığınızı ve kabul ettiğinizi beyan edersiniz. Eğer bu şartları kabul etmiyorsanız,
                        lütfen platformu kullanmayı derhal bırakın.
                    </p>

                    <h3 style={{ color: 'var(--text)', marginBottom: 10, fontSize: 15 }}>2. Hesap Sorumluluğu</h3>
                    <p style={{ marginBottom: 20 }}>
                        Kullanıcılar, hesap bilgilerinin gizliliğini korumakla yükümlüdür. Hesabınız üzerinden gerçekleştirilen
                        her türlü işlem kendi sorumluluğunuzdadır. Gerçeğe aykırı bilgilerle (spam, bot) hesap
                        oluşturulması kesinlikle yasaktır ve tespiti halinde hesap kalıcı olarak silinecektir.
                    </p>

                    <h3 style={{ color: 'var(--text)', marginBottom: 10, fontSize: 15 }}>3. Topluluk Kuralları ve Davranış</h3>
                    <ul style={{ marginBottom: 20, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <li>Platformda şiddet, nefret söylemi, ırkçılık veya ayrımcılık içeren hiçbir içeriğe izin verilmez.</li>
                        <li>Yetişkinlere yönelik cinsel içerikli (NSFW) veya yasa dışı her türlü paylaşım kesinlikle yasaktır.</li>
                        <li>Diğer kullanıcıları taciz etmek, zorbalık yapmak, tehdit etmek kabul edilemez.</li>
                        <li>Canlı yayınlarda ve sohbetlerde telif hakkı ihlali yapılması yasaktır.</li>
                        <li style={{ color: 'var(--coral)', fontWeight: 600 }}>İhlaller durumunda Buddy Live moderasyon ekibi hesabı askıya alma veya kalıcı olarak kapatma hakkını saklı tutar.</li>
                    </ul>

                    <h3 style={{ color: 'var(--text)', marginBottom: 10, fontSize: 15 }}>4. Sanal Paralar (Elmas) ve Ödemeler</h3>
                    <p style={{ marginBottom: 20 }}>
                        Platform üzerinden satın alınan Elmaslar ve sanal hediyeler gerçek para değerine dönüştürülemez ve
                        iade edilemez. Yapılan satın alma işlemleri kesin olup, yasal yükümlülükler dışında iade süreci işletilmez.
                    </p>

                    <h3 style={{ color: 'var(--text)', marginBottom: 10, fontSize: 15 }}>5. Veri ve Gizlilik</h3>
                    <p style={{ marginBottom: 40 }}>
                        Profil verileriniz, oturum bilgileriniz ve tercihleriniz Buddy Live Güvenlik Protokolleri ile saklanmaktadır.
                        Yayınlar ve genel odalardaki mesajlarınız diğer kullanıcılar tarafından görülebilir ve Buddy Live moderasyon
                        algoritmaları tarafından izlenebilir. Daha fazla detay için Gizlilik Politikasını okuyun.
                    </p>

                    <div style={{ textAlign: 'center', fontSize: 11, marginBottom: 20 }}>
                        Son Güncelleme: Mart 2026<br />
                        © 2026 Buddy Live. Tüm hakları saklıdır.
                    </div>
                </div>
            </div>
        </div>
    );
};
